import { Component, ElementRef } from '@angular/core';
import { DesignAttributeType } from '../../../../types/designer-attribute-type';
import { BaseDesignerComponent } from "../../base/base-designer-component";

@Component({
    selector: 'sx-email-designer',
    templateUrl: './email.designer.component.html'
})
export class SxEmailDesigner extends BaseDesignerComponent {
    constructor(container: ElementRef){
        super(container, "SxEmail");
    }
    loadDefaults(): void {
        super.loadDefaults();
        this.controlContext.email = '';
    }

    getDesignerInfo(): any {
        let info = super.getDesignerInfo();

        info["email"] = this.controlContext.email;

        return info;
    }
    buildAttributes(): void {
        super.buildAttributes();

        let mailAtt = new DesignAttributeType(this.controlContext, "string", "email");

        this.attributes.push(mailAtt);
    }
}


// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/components/designers/layout/deprecated/email.designer.component.ts